module.exports = __webpack_public_path__ + "static/media/bypass_right.6a842f7e.png";